import React, {Component} from 'react';
import {withRouter, Route} from 'react-router-dom';
import {connect} from 'react-redux';

// styles
import style from '../../Styles/Containers/Auth.module.css'

//component
import Logo from "../../Components/Logo";
import ModalSmallComponent from '../../Components/modal/ModalSmall'
import Input from '../../Components/Input'
import Button from '../../Components/Button'
import InputTitle from '../../Components/Input/InputTitle'
import {action} from '../../Data/index';
import Spinner from '../../Components/Spinner'
import { logClientEvent } from '../../Lib/clientEventLog';
import { CloudfrontImage } from '../../Components/CloudfrontAsset';

// Actions

// Consts
import * as Const from "../../Data/const";
import { withTranslation, withNamespaces } from "react-i18next";

const AUTO_LITE_VALIDATION_DELAY_MS = 500;

class AuthContainer extends Component {
    constructor() {
        super();
        this.state = {
            isCheckCode: false,
            isLoading: true,
            showModal: false,
            productReleaseCode: '',
            showExpiredModal: false,
            showDeniedModal: false,
            isConfirming: false,
            productReleaseCodeConfirmed: null,
            validatedProductReleaseCode: '',
            confirmCount: 0,
            companyLogoUrl: '',
            isMagnetic : false,
            url : ''
        }
        this.isConfirming = false;
        this.isUnmounted = false;
        this.fallbackUUID = null;
        this.liteValidationTimer = null;
        this.liteValidationRequestId = 0;
        this.init = this.init.bind(this);
        this.getLiteConfirmParams = this.getLiteConfirmParams.bind(this);
        this.getConfirmParams = this.getConfirmParams.bind(this);
        this.getParameterByName = this.getParameterByName.bind(this);
        this.checkCode = this.checkCode.bind(this);
        this.setUUID = this.setUUID.bind(this);
    }

    componentDidMount() {
        this.isUnmounted = false;
        this.setState({ locale: this.props.COUNTRY_CODE || 'en' });

        window.addEventListener('getUUID', this.setUUID);
        this.init();
    }

    componentWillUnmount() {
        this.isUnmounted = true;
        if (this.liteValidationTimer) clearTimeout(this.liteValidationTimer);
        this.liteValidationRequestId += 1;
        window.removeEventListener('getUUID', this.setUUID);
    }

    setConfirming(isConfirming) {
        this.isConfirming = isConfirming;
        if (!this.isUnmounted) {
            this.setState({ isConfirming });
        }
    }

    getRequestUUID() {
        if (this.props.UUID) return this.props.UUID;
        if (!this.fallbackUUID) this.fallbackUUID = Const.getUUID();
        return this.fallbackUUID;
    }

    withTimeout(promise, timeoutMs, errorMessage) {
        return Promise.race([
            promise,
            new Promise((resolve, reject) => {
                setTimeout(() => reject(new Error(errorMessage || 'timeout')), timeoutMs);
            })
        ]);
    }

    async init() {
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iosHandler) {
            window.webkit.messageHandlers.iosHandler.postMessage({functionName: 'getUUID'});
        } else {
            await this.setUUID();
        }

        logClientEvent('auth_mount', {
            productReleaseCode: this.getParameterByName('id'),
            path: window.location.pathname,
            uuidSource: window.__nbLastUUIDSource,
        });

        let params = this.getLiteConfirmParams();

        if (!params.productReleaseCode) {
            this.setState({isLoading: false});
            return;
        }

        logClientEvent('auth_lite_api_start', {
            productReleaseCode: params.productReleaseCode,
            uuidSource: window.__nbLastUUIDSource,
        });
        this.props.dispatch(action.eUSER.getProductConfirmLite(params))
            .then((response) => {
                logClientEvent('auth_lite_api_success', {
                    productReleaseCode: params.productReleaseCode,
                    uuidSource: window.__nbLastUUIDSource,
                });
                this.setState({
                    isLoading: false,
                    companyLogoUrl: response.companyLogoUrl,
                    productReleaseCode: response.productReleaseCode,
                    validatedProductReleaseCode: response.productReleaseCode,
                    confirmCount: typeof response.confirmCount === 'number' ? response.confirmCount : 0
                })
            })
            .catch((err) => {
                logClientEvent('auth_lite_api_fail', {
                    severity: 'error',
                    productReleaseCode: params.productReleaseCode,
                    uuidSource: window.__nbLastUUIDSource,
                    message: err && err.message,
                    response: err && err.response && err.response.data,
                });
                this.setState({
                    isLoading: false,
                }, () => {
                    if (err.response) {
                        let errData = Const.getError(err.response.data, (this.props.COUNTRY_CODE || 'en'));
                        if (!errData.code) {
                            Const.showAlert('', errData.errorMessage);
                            return;
                        }

                        if (errData.code === 'PRODUCT_AUTH_WRONG') {
                          // 이 부분 수정
                          //this.props.history.push('/user/auth/error?id=' + productReleaseCode);
                            this.props.history.push('/user/auth/error?id=' + params.productReleaseCode);
                        } else if (errData.code === 'PRODUCT_AUTH_EXPIRED' || errData.code === 'PRODUCT_AUTH_OVER') {
                            this.setState({ showExpiredModal: true })
                        } else if (errData.code === 'PRODUCT_AUTH_DENIED') {
                            this.setState({ showDeniedModal: true })
                        }
                    } else {
                        console.log('Unknown err', err)
                    }
                })
            });
    }

    async setUUID(event) {
        let uuid;

        if (event) {
            uuid = event.detail.uuid;
        } else {
            uuid = await Const.getUUID();

        }

        if (!uuid) uuid = this.getRequestUUID();
        await this.props.dispatch(action.eSESSION.setUUID(uuid));
    }

    handleChange(e) {
        const productReleaseCode = e.target.value;
        const requestId = ++this.liteValidationRequestId;

        if (this.liteValidationTimer) {
            clearTimeout(this.liteValidationTimer);
            this.liteValidationTimer = null;
        }

        this.setState({
            [e.target.name]: productReleaseCode,
            validatedProductReleaseCode: '',
            confirmCount: 0,
            companyLogoUrl: '',
        }, () => {
            if (!productReleaseCode.trim() || this.isUnmounted) return;

            this.liteValidationTimer = setTimeout(() => {
                this.liteValidationTimer = null;
                this.validateTypedCode(productReleaseCode, requestId);
            }, AUTO_LITE_VALIDATION_DELAY_MS);
        });
    }

    validateTypedCode(productReleaseCode, requestId) {
        if (this.isUnmounted || requestId !== this.liteValidationRequestId) return;

        const params = this.getLiteConfirmParams(productReleaseCode);
        this.props.dispatch(action.eUSER.getProductConfirmLite(params))
            .then((response) => {
                if (this.isUnmounted ||
                    requestId !== this.liteValidationRequestId ||
                    this.state.productReleaseCode !== productReleaseCode ||
                    response.productReleaseCode !== productReleaseCode) return;

                logClientEvent('auth_lite_auto_success', {
                    productReleaseCode,
                    uuidSource: window.__nbLastUUIDSource,
                });
                this.setState({
                    companyLogoUrl: response.companyLogoUrl,
                    validatedProductReleaseCode: response.productReleaseCode,
                    confirmCount: typeof response.confirmCount === 'number' ? response.confirmCount : 0,
                });
            })
            .catch((err) => {
                if (this.isUnmounted || requestId !== this.liteValidationRequestId) return;

                // Partial and invalid codes are expected while typing. Only transport failures need diagnostics.
                if (!err || !err.response) {
                    logClientEvent('auth_lite_auto_fail', {
                        severity: 'error',
                        productReleaseCode,
                        uuidSource: window.__nbLastUUIDSource,
                        message: err && err.message,
                    });
                }
            });
    }

    getCurrentPositionAsync = (options) => {
        return new Promise((resolve, reject) => {
            if (!navigator.geolocation) return reject(new Error("Geolocation not supported"));
            navigator.geolocation.getCurrentPosition(resolve, reject, options);
        });
    };
    getLiteConfirmParams(productReleaseCode) {
        return {
            uuid: this.getRequestUUID(),
            productReleaseCode: typeof productReleaseCode === 'string'
                ? productReleaseCode
                : this.getParameterByName('id'),
            ELocale: this.props.COUNTRY_CODE || 'en',
        }
    }
    async getConfirmParams() {
        let productReleaseCode = this.getParameterByName('id') //
        let uuid = this.getParameterByName('uuid') // 삭제예정 , Root.jsx에서 getUUID로 받아옴
        let time = this.getParameterByName('time'); //
        let lng = this.getParameterByName('lng'); //
        let lat = this.getParameterByName('lat');
        let country = this.getParameterByName('country');
        let city = this.getParameterByName('city');
        let ELocale = 'en';

        // geolocation 넣기
        try {
            logClientEvent('geo_start', { productReleaseCode });
            const pos = await this.withTimeout(this.getCurrentPositionAsync({
                enableHighAccuracy: false,
                timeout: 3000,
                maximumAge: 60000
            }), 3500, 'geo_timeout');
            lat = pos.coords.latitude;
            lng = pos.coords.longitude;
            if (!country || country === 'South Korea' || country === 'Korea') country = 'Unknown';
            if (!city || city === 'Seoul') city = 'Unknown';
            logClientEvent('geo_success', { productReleaseCode, lat, lng });
        } catch (e) {
            logClientEvent('geo_fail', { productReleaseCode, message: e && e.message });
            console.log("geolocation try1 error: ", e)
            logClientEvent('geo_unavailable', { productReleaseCode, fallback: 'server_ip' });
        }

        return {
            uuid: this.getRequestUUID(),
            uuidSource: window.__nbLastUUIDSource,
            clientDedupeId: Const.getConfirmClientId(),
            productReleaseCode: productReleaseCode,
            ELocale: this.props.COUNTRY_CODE || 'en',
            confirmGeoCode: {
                lat: lat || "asdf",  // asdf 시 별도 처리하도록 서버로직에 있음 (util_map.js)
                lng: lng || "asdf",
                country: country || "Unknown",
                city: city || "Unknown"
            }
        }
    }

    getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    async checkCode() {
        if (this.isConfirming) {
            logClientEvent('auth_confirm_duplicate_ignored', {
                productReleaseCode: this.state.productReleaseCode,
            });
            return;
        }

        if (!this.state.productReleaseCode) {
            Const.showAlert('', this.props.t('insert_security_code'));
            return;
        }

        if (this.liteValidationTimer) {
            clearTimeout(this.liteValidationTimer);
            this.liteValidationTimer = null;
        }
        this.liteValidationRequestId += 1;

        this.setConfirming(true);
        const confirmGuard = setTimeout(() => {
            if (this.isConfirming) {
                logClientEvent('auth_confirm_guard_release', {
                    productReleaseCode: this.state.productReleaseCode,
                });
                this.setConfirming(false);
            }
        }, 15000);
        let params;
        try {
            params = await this.getConfirmParams();
            let user = this.props.eSESSION.user;

            params.productReleaseCode = this.state.productReleaseCode;
            if (user) params.uid = user.uid;

            logClientEvent('auth_confirm_api_start', {
                productReleaseCode: params.productReleaseCode,
                confirmGeoCode: params.confirmGeoCode,
                uuidSource: window.__nbLastUUIDSource,
            });
            const res = await this.props.dispatch(action.eUSER.getProductConfirm(params));
            logClientEvent('auth_confirm_api_success', { productReleaseCode: params.productReleaseCode });
            logClientEvent('auth_confirm_result', {
                productReleaseCode: params.productReleaseCode,
                isDuplicateConfirm: res && res.isDuplicateConfirm,
                duplicateReason: res && res.duplicateReason,
                uuidSource: window.__nbLastUUIDSource,
            });
            if (res.product) {
                this.props.history.push('/user/product?id=' + this.state.productReleaseCode)
            }
        } catch (err) {
            logClientEvent('auth_confirm_api_fail', {
                severity: 'error',
                productReleaseCode: params && params.productReleaseCode,
                uuidSource: window.__nbLastUUIDSource,
                message: err && err.message,
                response: err && err.response && err.response.data,
            });
            if (err.response) {
                let errData = Const.getError(err.response.data, (this.props.COUNTRY_CODE || 'en'));
                if (!errData.code) {
                    Const.showAlert('', errData.errorMessage);
                    return;
                }

                if (errData.code === 'PRODUCT_AUTH_WRONG') {
                    this.props.history.push('/user/auth/error?id=' + this.state.productReleaseCode);
                } else if (errData.code === 'PRODUCT_AUTH_EXPIRED' || errData.code === 'PRODUCT_AUTH_OVER') {
                    this.setState({ showExpiredModal: true })
                } else if (errData.code === 'PRODUCT_AUTH_DENIED') {
                    this.setState({ showDeniedModal: true })
                }
            } else {
                console.log('Unknown err', err)
            }
        } finally {
            clearTimeout(confirmGuard);
            this.setConfirming(false);
        }
    }
    get expiredModal() {
        return <ModalSmallComponent
            visible={this.state.showExpiredModal}
            topContent={<CloudfrontImage
                src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-alert.svg"}
                logContext={{ component: 'Auth', assetType: 'expired-alert' }}
            />}
            middleContent={this.props.t('expired_authentication')}
            bottomContent={
                <React.Fragment>
                    <div style={{whiteSpace: 'pre-wrap'}}>{this.props.t('contact_customer_center')}</div>
                </React.Fragment>
            }
            confirmFont={this.props.t('confirm')}//기본값 "확인" 값을 넘기면 해당 글자가 버튼에 표시
            onConfirm={() => {
                Const.userAppCloseActivity();
                this.setState({
                    showExpiredModal: false
                });
            }}
        />
    }

    get deniedModal() {
        const { t } = this.props;
        return <ModalSmallComponent
            visible={this.state.showDeniedModal}
            topContent={<CloudfrontImage
                src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-alert.svg"}
                logContext={{ component: 'Auth', assetType: 'denied-alert' }}
            />}
            middleContent={t('product_not_exist')}
            bottomContent={
                <React.Fragment>
                    <span>{t('product_not_exist_detail')}</span>
                </React.Fragment>
            }
            confirmFont={this.props.t('confirm')}//기본값 "확인" 값을 넘기면 해당 글자가 버튼에 표시
            onConfirm={() => {
                Const.userAppCloseActivity();
                this.setState({
                    showDeniedModal: false
                });
            }}
        />
    }

    render() {
        const { t } = this.props;

        const {
            productReleaseCode,
            product
        } = this.state;
        const isValidatedCode = this.state.validatedProductReleaseCode &&
            productReleaseCode === this.state.validatedProductReleaseCode;

        return (
            <React.Fragment>
                <div className={style.container}>
                    {this.state.isLoading ? <div className={style.spinnerWrapper}><Spinner/></div> :
                        (
                            <React.Fragment>
                                <Logo imgSrc={this.state.companyLogoUrl}></Logo>
                                <div className={style.lock_area}>
                                    <CloudfrontImage
                                        src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-lock.svg"}
                                        className={style.ic_lock}
                                        logContext={{ component: 'Auth', assetType: 'lock' }}
                                    />
                                </div>
                                <div className={`${style.auth_code} ${isValidatedCode ? style.valid_auth_code : ''}`}>
                                    <span>
                                        {isValidatedCode
                                            ? t('valid_security_code', {count: this.state.confirmCount})
                                            : t('insert_security_code')}
                                    </span>
                                </div>
                                <div className={style.input_area}>
                                    <InputTitle title={t('security_code')}>
                                        {/*<Input placeholder={"승인코드를 입력해주세요"}
                                           onChange={(e) => this.handleChange(e)}
                                           value={this.state.productReleaseCode}
                                           name='productReleaseCode'3

                                    />*/}
                                        <Input value={this.state.productReleaseCode} onChange={(e) => this.handleChange(e)} name={'productReleaseCode'}/>
                                    </InputTitle>
                                </div>
                                <div className={style.confirm_container}>
                                    <Button title={t('confirm')}
                                            onClick={this.state.isConfirming ? () => {} : this.checkCode}/>
                                </div>
                            </React.Fragment>
                        )
                       }
                </div>
                {this.expiredModal}
                {this.deniedModal}
            </React.Fragment>
        )
    }
}

export default connect((state) => {
    return {
        eSESSION: state.data.eSESSION.eSESSION,
        COUNTRY_CODE: state.data.eSESSION.COUNTRY_CODE,
        UUID: state.data.eSESSION.UUID,
    }
})(withRouter(withTranslation()(AuthContainer)))
